import ReactMarkdown from 'react-markdown';
import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDashboard } from './Dashboardcontext';
import { 
  Bot,
  ChevronRight,
  Share,
  User,
  Menu,
  ChevronDown,
  Edit3,
  Paperclip,
  Plus,
  Sparkles,
  ThumbsUp,
  Repeat2,
  MessageCircle,
  MoreHorizontal,
  Calendar,
  Clock,
  Download,
  Eye,
  ArrowLeft,
  ExternalLink,
  Trash2,
  X,
  Send,
  ArrowUp,
  Copy,
  Check,
  Edit2
} from 'lucide-react';
import Sidebar from './Sidebar';
import Header from './Header';
import LinkedInConnectionModal from './LinkedInConnectionModal';
import { useLinkedInAccount } from '../hooks/useLinkedInAccount';

const CreatePostPage = () => {
  const [activeTab, setActiveTab] = useState('create-post');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [postDescription, setPostDescription] = useState('');
  const [selectedDraft, setSelectedDraft] = useState(null);
  const [scheduleYear, setScheduleYear] = useState(new Date().getFullYear());
  const [scheduleMonth, setScheduleMonth] = useState(new Date().getMonth());
  const [scheduleDay, setScheduleDay] = useState(new Date().getDate());
  const [scheduleHour, setScheduleHour] = useState(12);
  const [scheduleMinute, setScheduleMinute] = useState(0);
  const [scheduleAMPM, setScheduleAMPM] = useState('AM');
  const [scheduleTimezone, setScheduleTimezone] = useState('UTC+05:30 (IST)');
  const [postObjective, setPostObjective] = useState('');
  const [toneStyle, setToneStyle] = useState('');
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [isGeneratingDrafts, setIsGeneratingDrafts] = useState(false);
  const [drafts, setDrafts] = useState([]);
  const [isLoadingPost, setIsLoadingPost] = useState(false);
 const [sessionId, setSessionId] = useState('');
 const { fetchDashboardData } = useDashboard();
 const [previewDraft, setPreviewDraft] = useState(null);
const [showLinkedInModal, setShowLinkedInModal] = useState(false);
const [linkedinStatus, setLinkedinStatus] = useState('guest');
const [imageBlobUrls, setImageBlobUrls] = useState({});
 const { accountId, accountType } = useLinkedInAccount();

 const [editingMessageId, setEditingMessageId] = useState(null);
// const [editingContent, setEditingContent]     = useState('');
const [copiedMessageId, setCopiedMessageId]   = useState(null);
const [copiedDraftId, setCopiedDraftId] = useState(null);
// const editTextareaRef = useRef(null);


// WITH THIS:
const loadImageWithAuth = async (imageUrl) => {
  if (!imageUrl || imageBlobUrls[imageUrl]) return;

  try {
    if (imageUrl.includes('pollinations') || imageUrl.includes('gen.pollinations')) {
      // Pollinations needs auth header
      const response = await fetch(imageUrl, {
        headers: { 'Authorization': 'Bearer sk_C0b3Uuggp5suCiGRqmv5khYs01SsXRPj' }
      });
      if (response.ok) {
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);
        setImageBlobUrls(prev => ({ ...prev, [imageUrl]: blobUrl }));
      }
    } else {
      // Unsplash / any other public URL — no auth needed
      setImageBlobUrls(prev => ({ ...prev, [imageUrl]: imageUrl }));
    }
  } catch (error) {
    console.error('Error loading image:', error);
  }
};

  // ✅ ADD: Load all draft images when drafts change
  useEffect(() => {
    drafts.forEach(draft => {
      if (draft.image) {
        loadImageWithAuth(draft.image);
      }
    });
  }, [drafts]);

  // ✅ ADD: Cleanup blob URLs on unmount
  useEffect(() => {
    return () => {
      Object.values(imageBlobUrls).forEach(blobUrl => {
        if (blobUrl.startsWith('blob:')) {
          URL.revokeObjectURL(blobUrl);
        }
      });
    };
  }, []);
// Add this function near the top of the component
const saveSchedulingState = () => {
  const schedulingState = {
    currentStep,
    selectedDraft,
    drafts,
    postDescription,
    postObjective,
    toneStyle,
    scheduleYear,
    scheduleMonth,
    scheduleDay,
    scheduleHour,
    scheduleMinute,
    scheduleAMPM,
    scheduleTimezone,
    timestamp: Date.now()
  };
  
  localStorage.setItem('schedulingState', JSON.stringify(schedulingState));
  console.log('💾 Saved scheduling state:', schedulingState);
};

const clearSchedulingState = () => {
  localStorage.removeItem('schedulingState');
  console.log('🗑️ Cleared scheduling state');
};
  const location = useLocation();
  const navigate = useNavigate();
  



// ── STEP 4: Copy handler ──
const handleCopyMessage = async (messageId, content) => {
  try {
    await navigator.clipboard.writeText(content);
    setCopiedMessageId(messageId);
    setTimeout(() => setCopiedMessageId(null), 2000);
  } catch {
    // Fallback for older browsers
    const el = document.createElement('textarea');
    el.value = content;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    setCopiedMessageId(messageId);
    setTimeout(() => setCopiedMessageId(null), 2000);
  }
};
const handleCopyDraft = async (draftId, content) => {
  try {
    await navigator.clipboard.writeText(content);
    setCopiedDraftId(draftId);
    setTimeout(() => setCopiedDraftId(null), 2000);
  } catch {
    const el = document.createElement('textarea');
    el.value = content;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    setCopiedDraftId(draftId);
    setTimeout(() => setCopiedDraftId(null), 2000);
  }
};

// Add this useEffect near other useEffects
useEffect(() => {
  // Check if there's a saved scheduling state
  const savedState = localStorage.getItem('schedulingState');
  
  if (savedState) {
    try {
      const state = JSON.parse(savedState);
      
      // Only restore if it's recent (within 5 minutes)
      const isRecent = Date.now() - state.timestamp < 5 * 60 * 1000;
      
      if (isRecent) {
        console.log('🔄 Restoring scheduling state:', state);
        
        // Restore all state
        setCurrentStep(state.currentStep);
        setSelectedDraft(state.selectedDraft);
        setDrafts(state.drafts || []);
        setPostDescription(state.postDescription || '');
        setPostObjective(state.postObjective || '');
        setToneStyle(state.toneStyle || '');
        setScheduleYear(state.scheduleYear);
        setScheduleMonth(state.scheduleMonth);
        setScheduleDay(state.scheduleDay);
        setScheduleHour(state.scheduleHour);
        setScheduleMinute(state.scheduleMinute);
        setScheduleAMPM(state.scheduleAMPM);
        setScheduleTimezone(state.scheduleTimezone);
        
        // Clear the saved state after restoring
        clearSchedulingState();
      } else {
        // State is too old, clear it
        clearSchedulingState();
      }
    } catch (error) {
      console.error('Error restoring scheduling state:', error);
      clearSchedulingState();
    }
  }
}, []); // Run only on mount

// When the user saves an edit:
//   • Trim messages after the edited one (removes subsequent AI reply & user turns)
//   • Replace the edited message with the new content
//               (remove the editingContent references, accept param instead)

const handleSaveEdit = async (messageId, newContent) => {  // ← newContent as param
  const messageIndex = chatMessages.findIndex(m => m.id === messageId);
  const updatedMessage = {
    ...chatMessages[messageIndex],
    content: newContent,
    edited: true,
    timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
  };

  const trimmedHistory = [
    ...chatMessages.slice(0, messageIndex),
    updatedMessage,
  ];

  setChatMessages(trimmedHistory);
  setEditingMessageId(null);
  setIsAIResponding(true);

  try {
    const payload = {
      sessionId,
      message: newContent,
      postObjective,
      toneStyle,
      attachedFiles: attachedFiles.map(f => ({ name: f.name, size: f.size, type: f.type })),
      chatHistory: trimmedHistory.slice(-10),
      isEdit: true,
    };

    const response = await fetch('https://n8n.acespireconsulting.com/webhook/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
      signal: AbortSignal.timeout(30000),
    });

    if (response.ok) {
      const result = await response.json();
      setChatMessages(prev => [...prev, {
        id: Date.now() + 1,
        type: 'ai',
        content: result.message || 'I understand. How can I help you refine this further?',
        timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      }]);
    } else {
      setChatMessages(prev => [...prev, {
        id: Date.now() + 1,
        type: 'ai',
        content: `Got your updated message: "${newContent}". Would you like me to refine this further or generate drafts?`,
        timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      }]);
    }
  } catch {
    setChatMessages(prev => [...prev, {
      id: Date.now() + 1,
      type: 'ai',
      content: `Understood — "${newContent}". Let me know how you'd like to proceed!`,
      timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
    }]);
  } finally {
    setIsAIResponding(false);
  }
};


// Add this near your other useEffects
useEffect(() => {
  // Push a state to history when component mounts
  window.history.pushState({ page: 'create-post' }, '');
  
  const handlePopState = (event) => {
    // Prevent default back button behavior
    event.preventDefault();
    
    // Handle back button based on current step
    if (currentStep === 4) {
      // From confirmation, go to schedule
      setCurrentStep(3);
      window.history.pushState({ page: 'create-post' }, '');
    } else if (currentStep === 3) {
      // From schedule, go to drafts
      setCurrentStep(2);
      window.history.pushState({ page: 'create-post' }, '');
    } else if (currentStep === 2) {
      // From drafts, go to prompt
      setCurrentStep(1);
      window.history.pushState({ page: 'create-post' }, '');
    } else if (currentStep === 1) {
      // From prompt (Step 1), go to dashboard
      navigate('/dashboard');
    }
  };
  
  // Add event listener for browser back button
  window.addEventListener('popstate', handlePopState);
  
  // Cleanup
  return () => {
    window.removeEventListener('popstate', handlePopState);
  };
}, [currentStep, navigate]);

 useEffect(() => {
  // Simple check on page load - just trust localStorage
  const accountId = localStorage.getItem('selectedLinkedInAccountId');
  const status = localStorage.getItem('linkedinStatus');
  
  console.log('🔍 Init check - accountId:', accountId, 'status:', status);
  
  if (accountId && status === 'connected') {
    console.log('✅ Using cached LinkedIn status: connected');
    setLinkedinStatus('connected');
  } else {
    console.log('👤 No LinkedIn connection found, setting to guest');
    setLinkedinStatus('guest');
  }
}, []);


  // Add state for edit/reschedule mode
  const [editMode, setEditMode] = useState(null);
  const [postIdToEdit, setPostIdToEdit] = useState(null);
  
  // New chat functionality states
  const [chatMessages, setChatMessages] = useState([]);
  const [isAIResponding, setIsAIResponding] = useState(false);
  
  // Ref for textarea to maintain focus
  const textareaRef = useRef(null);
  const chatContainerRef = useRef(null);
  const prevMessageCountRef = useRef(0);
// ── Replace the existing scroll useEffect with this ──
useEffect(() => {
  const currentCount = chatMessages.length;
  const prevCount = prevMessageCountRef.current;
  
  // Only scroll to bottom when a NEW message is ADDED (count increases)
  // Don't scroll when editing replaces a message (count stays same or decreases)
  if (currentCount > prevCount && chatContainerRef.current) {
    // Small delay to let DOM update
    requestAnimationFrame(() => {
      if (chatContainerRef.current) {
        chatContainerRef.current.scrollTo({
          top: chatContainerRef.current.scrollHeight,
          behavior: 'smooth'
        });
      }
    });
  }
  
  prevMessageCountRef.current = currentCount;
}, [chatMessages]);
  
// Generate or retrieve session ID on component mount - NEW
  useEffect(() => {
    const generateSessionId = () => {
      // Try to get existing session from localStorage
      let existingSession = localStorage.getItem('chatSessionId');
      
      if (!existingSession) {
        // Generate new session ID: timestamp + random string
        const timestamp = Date.now();
        const randomStr = Math.random().toString(36).substring(2, 15);
        existingSession = `session_${timestamp}_${randomStr}`;
        localStorage.setItem('chatSessionId', existingSession);
      }
      
      setSessionId(existingSession);
      console.log('Session ID:', existingSession);
    };

    generateSessionId();
  }, []);

  // Download image handler
// WITH THIS:
const handleDownloadImage = async (imageUrl, draftId) => {
  try {
    const fetchOptions = imageUrl.includes('pollinations')
      ? { headers: { 'Authorization': 'Bearer sk_C0b3Uuggp5suCiGRqmv5khYs01SsXRPj' } }
      : {};  // public URLs need no auth

    const response = await fetch(imageUrl, fetchOptions);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `draft-${draftId}-image.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download image:', error);
    alert('Failed to download image. Please try again.');
  }
};

  // Optional: Create new session when starting a new post - NEW
  const createNewSession = () => {
    const timestamp = Date.now();
    const randomStr = Math.random().toString(36).substring(2, 15);
    const newSessionId = `session_${timestamp}_${randomStr}`;
    localStorage.setItem('chatSessionId', newSessionId);
    setSessionId(newSessionId);
    setChatMessages([]); // Clear chat history for new session
    console.log('New Session ID:', newSessionId);
  };
  // Scroll to bottom of chat when new messages are added
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [chatMessages]);

  // Ensure textarea stays focused
  useEffect(() => {
    if (textareaRef.current && !isGeneratingDrafts && !isAIResponding) {
      textareaRef.current.focus();
    }
  }, [postDescription, isGeneratingDrafts, isAIResponding]);

 // Update useEffect
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const editId = searchParams.get('edit');
    const rescheduleId = searchParams.get('reschedule');
    
    if (editId) {
      setIsLoadingPost(true);
      setEditMode('edit');
      setPostIdToEdit(editId);
      fetchPostData(editId, 'edit').finally(() => setIsLoadingPost(false));
    } else if (rescheduleId) {
      setIsLoadingPost(true);
      setEditMode('reschedule');
      setPostIdToEdit(rescheduleId);
      fetchPostData(rescheduleId, 'reschedule').finally(() => setIsLoadingPost(false));
    }
  }, [location.search]);
  // Handle textarea input without losing focus and with proper cursor positioning
  const handleTextInput = (e) => {
    const textarea = e.target;
    const cursorPosition = textarea.selectionStart;
    const newValue = e.target.value;
    
    setPostDescription(newValue);
    
    // Restore cursor position after state update
    requestAnimationFrame(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
        textareaRef.current.setSelectionRange(cursorPosition, cursorPosition);
      }
    });
  };

  // Handle Enter key press for chat functionality
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (postDescription.trim()) {
        sendMessageToAI();
      }
    }
  };

  // Send message to AI assistant
  const sendMessageToAI = async () => {
    if (!postDescription.trim() || !sessionId) return;

    const userMessage = {
      id: Date.now(),
      type: 'user',
      content: postDescription.trim(),
      timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };

    setChatMessages(prev => [...prev, userMessage]);
    setIsAIResponding(true);
    
    // Clear the input
    const currentInput = postDescription.trim();
    setPostDescription('');

    try {
      // Prepare payload for AI chat endpoint (different from draft generation)
      const payload = {
        sessionId: sessionId, // ← SESSION ID ADDED HERE
        message: currentInput,
        postObjective: postObjective,
        toneStyle: toneStyle,
        attachedFiles: attachedFiles.map(file => ({
  name: file.name,
  size: file.size,
  type: file.type,
  base64: file.base64   // ← add this line
})),
        chatHistory: chatMessages.slice(-10) // Send last 10 messages for context
      };

      // Call AI chat endpoint
      const response = await fetch('https://n8n.acespireconsulting.com/webhook/chat', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
        signal: AbortSignal.timeout(30000) // 30 second timeout
      });

      if (response.ok) {
        const result = await response.json();
        const data = Array.isArray(result) ? result[0] : result;
        
        
        // ✅ CORRECT — store raw string, render Markdown only in the display layer
const aiMessage = {
  id: Date.now() + 1,
  type: 'ai',
  content: result.message || 'I understand. How can I help you refine this further?',  // ← plain string
  timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
};

        setChatMessages(prev => [...prev, aiMessage]);
      } else {
        // Fallback AI response
        const aiMessage = {
          id: Date.now() + 1,
          type: 'ai',
          content: `I understand you want to create content about: "${currentInput}". This sounds like a great topic for a post. Would you like me to help you refine the message, suggest improvements, or are you ready to generate draft posts?`,
          timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
        };

        setChatMessages(prev => [...prev, aiMessage]);
      }
    } catch (error) {
      // Fallback AI response on error
      const aiMessage = {
        id: Date.now() + 1,
        type: 'ai',
        content: `I see you want to create content about: "${currentInput}". That's an interesting topic! I can help you develop this idea further. What specific angle or message would you like to focus on? Or would you prefer to generate draft posts right away?`,
        timestamp: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      };

      setChatMessages(prev => [...prev, aiMessage]);
    } finally {
      setIsAIResponding(false);
    }
  };

  // Generate years (current year to next 2 years)
  const years = Array.from({length: 10}, (_, i) => new Date().getFullYear() + i);
  
  // Month names
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  
  // Generate days based on selected month/year
  const getDaysInMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  };
  
  const days = Array.from({length: getDaysInMonth(scheduleMonth, scheduleYear)}, (_, i) => i + 1);
  
  // Generate hours (1-12)
  const hours = Array.from({length: 12}, (_, i) => i + 1);
  
  // Generate minutes (0-59, in 5-minute intervals)
  const minutes = Array.from({length: 12}, (_, i) => i * 5);
  
  // Common timezones
  const timezones = [
    'UTC-12:00 (Baker Island)',
    'UTC-11:00 (American Samoa)',
    'UTC-10:00 (Hawaii)',
    'UTC-09:00 (Alaska)',
    'UTC-08:00 (Pacific Time)',
    'UTC-07:00 (Mountain Time)',
    'UTC-06:00 (Central Time)',
    'UTC-05:00 (Eastern Time)',
    'UTC-04:00 (Atlantic Time)',
    'UTC-03:00 (Argentina)',
    'UTC-02:00 (South Georgia)',
    'UTC-01:00 (Azores)',
    'UTC+00:00 (GMT/UTC)',
    'UTC+01:00 (Central European)',
    'UTC+02:00 (Eastern European)',
    'UTC+03:00 (Moscow)',
    'UTC+04:00 (Gulf)',
    'UTC+05:00 (Pakistan)',
    'UTC+05:30 (IST)',
    'UTC+06:00 (Bangladesh)',
    'UTC+07:00 (Thailand)',
    'UTC+08:00 (China)',
    'UTC+09:00 (Japan)',
    'UTC+10:00 (Australia East)',
    'UTC+11:00 (Solomon Islands)',
    'UTC+12:00 (New Zealand)'
  ];

  // Handle file upload
  const handleFileUpload = async (event) => {
  const files = Array.from(event.target.files);
  
  const processedFiles = await Promise.all(files.map(async (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        resolve({
          name: file.name,
          size: file.size,
          type: file.type,
          base64: e.target.result.split(',')[1], // Remove data:image/png;base64, prefix
          fullBase64: e.target.result // Keep full for preview
        });
      };
      reader.readAsDataURL(file);
    });
  }));
  
  setAttachedFiles(prev => [...prev, ...processedFiles]);
};

  // Remove attached file
  const removeFile = (index) => {
    setAttachedFiles(prev => prev.filter((_, i) => i !== index));
  };

  // Format selected date for display
  const getFormattedDate = () => {
    return `${months[scheduleMonth]} ${scheduleDay}, ${scheduleYear}`;
  };

  // Generate drafts using N8N agent (modified to include chat context)
  const generateDrafts = async () => {
  setIsGeneratingDrafts(true);
  
  try {
    // FIXED: Include base64 data in the payload
    const payload = {
      prompt: postDescription || (chatMessages.length > 0 ? chatMessages[chatMessages.length - 2]?.content : ''),
      postObjective: postObjective,
      toneStyle: toneStyle,
      attachedFiles: attachedFiles.map(file => ({
        name: file.name,
        size: file.size,
        type: file.type,
        base64: file.base64  // ← THIS WAS MISSING!
      })),
      chatContext: chatMessages.slice(-6)
    };

    console.log('Sending to N8N:', {
      ...payload,
      attachedFiles: payload.attachedFiles.map(f => ({
        ...f,
        base64: f.base64 ? `${f.base64.substring(0, 50)}... (${f.base64.length} chars)` : 'MISSING'
      }))
    });

    // const controller = new AbortController();
    // const timeoutId = setTimeout(() => controller.abort(), 30000);

    const response = await fetch('https://n8n.acespireconsulting.com/webhook/webhook/create-post', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(payload),
      // signal: controller.signal
    });

    // clearTimeout(timeoutId);

    if (response.ok) {
      const responseText = await response.text();
      
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (parseError) {
        try {
          const doubleParseResult = JSON.parse(JSON.parse(responseText));
          result = doubleParseResult;
        } catch (doubleParseError) {
          alert(`N8N returned invalid JSON: ${responseText.substring(0, 200)}...`);
          setIsGeneratingDrafts(false);
          return;
        }
      }
      
      let draftsArray = [];
      
      if (Array.isArray(result)) {
        draftsArray = result;
      } else if (result && result.success && result.drafts) {
        if (Array.isArray(result.drafts)) {
          draftsArray = result.drafts;
        } else if (typeof result.drafts === 'string') {
          try {
            draftsArray = JSON.parse(result.drafts);
          } catch (e) {
            console.error('Failed to parse drafts string:', e);
          }
        }
      } else if (typeof result === 'string') {
        try {
          draftsArray = JSON.parse(result);
        } catch (e) {
          console.error('Failed to parse result string:', e);
        }
      }
      
      if (Array.isArray(draftsArray) && draftsArray.length > 0) {
        const transformedDrafts = draftsArray.map((item, index) => ({
  id: item.id || index + 1,
  user: 'Acespire consulting',
  date: 'now • 3rd',
  content: item.draft_content || item.content || 'No content available',
  translation: 'See translation',
  image: item.media_url || null,  // Always use media_url for the actual image
  facts: `Generated with ${item.tone_style || 'custom'} tone for ${item.post_objective || 'general'} objective`,
  engagement: { likes: 0, comments: 0, reposts: 0, shares: 0 },
  media_url: item.media_url,
  attached_file: item.attached_file  // Keep filename for reference
}));
        
        setDrafts(transformedDrafts);
        setCurrentStep(2);
      } else {
        alert(`Error: Expected array of drafts but got: ${JSON.stringify(result)}`);
        setIsGeneratingDrafts(false);
        return;
      }
    } else {
      const errorText = await response.text();
      alert(`N8N Error ${response.status}: ${response.statusText}\n${errorText}`);
      setIsGeneratingDrafts(false);
      return;
    }
  } catch (error) {
    if (error.name === 'AbortError') {
      alert('Request timed out. N8N workflow may be taking too long to process.');
    } else {
      alert(`Network error: ${error.message}\n\nPlease check:\n1. N8N workflow is active\n2. Webhook URL is accessible\n3. Your internet connection`);
    }
    setIsGeneratingDrafts(false);
    return;
  } finally {
    setIsGeneratingDrafts(false);
  }
};



// Update fetchPostData to accept mode parameter
 // Update fetchPostData to return a promise
  const fetchPostData = async (postId, mode) => {
    try {
      console.log('Fetching post data for ID:', postId, 'Mode:', mode);
      
      const response = await fetch('https://n8n.acespireconsulting.com/webhook/webhook/get-post-by-id', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ postId: parseInt(postId) })
      });

      const rawText = await response.text();
      
      if (!rawText) {
        alert('Empty response from server');
        navigate('/scheduled-posts');
        return;
      }

      let responseData;
      try {
        responseData = JSON.parse(rawText);
      } catch (parseError) {
        console.error('JSON parse error:', parseError);
        alert(`Invalid response format`);
        navigate('/scheduled-posts');
        return;
      }

      if (response.ok) {
        const data = Array.isArray(responseData) ? responseData[0] : responseData;
        
        if (!data || !data.success || !data.post) {
          alert('Post not found or already deleted');
          navigate('/scheduled-posts');
          return;
        }
        
        const post = data.post;
        
        // Use prompt if available, fallback to content
        let promptText = post.prompt;
        if (!promptText && post.content) {
          const firstSentence = post.content.split(/[.!?]/)[0];
          promptText = firstSentence.length > 150 ? post.content.substring(0, 150) + '...' : firstSentence;
        }
        
        // Create draft first
        const draftData = [{
          id: 1,
          user: 'Acespire consulting',
          date: 'now • 3rd',
          content: post.content,
          translation: 'See translation',
          image: post.media_url,
          facts: `Originally scheduled for ${new Date(post.scheduled_time).toLocaleDateString()}`,
          engagement: { likes: 0, comments: 0, reposts: 0, shares: 0 },
          media_url: post.media_url
        }];
        
        // Set schedule date/time
        const scheduledDate = new Date(post.scheduled_time);
        
        // Batch all state updates together
        await new Promise(resolve => {
          setPostDescription(promptText || '');
          setPostObjective(post.post_objective || '');
          setToneStyle(post.tone_style || '');
          setScheduleYear(scheduledDate.getFullYear());
          setScheduleMonth(scheduledDate.getMonth());
          setScheduleDay(scheduledDate.getDate());
          setScheduleHour(scheduledDate.getHours() % 12 || 12);
          setScheduleMinute(scheduledDate.getMinutes());
          setScheduleAMPM(scheduledDate.getHours() >= 12 ? 'PM' : 'AM');
          setDrafts(draftData);
          setSelectedDraft(1);
          
          // Small delay to ensure state is set
          setTimeout(resolve, 50);
        });
        
        // Now navigate based on mode
        console.log('Setting step based on mode:', mode);
        if (mode === 'reschedule') {
          console.log('Jumping to step 3 for reschedule');
          setCurrentStep(3);
        } else {
          console.log('Staying on step 1 for edit');
          setCurrentStep(1);
        }
      }
    } catch (error) {
      console.error('Error fetching post data:', error);
      alert(`Failed to load post data: ${error.message}`);
      navigate('/scheduled-posts');
    }
  };
 // Add this after the generateDrafts function
const schedulePost = async () => {
  console.log('🚀 ============ SCHEDULE POST CALLED ============');
  console.log('🚀 linkedinStatus state:', linkedinStatus);
  console.log('🚀 localStorage linkedinStatus:', localStorage.getItem('linkedinStatus'));
  
  // ✅ Read accountId from localStorage
  const accountIdFromStorage = localStorage.getItem('selectedLinkedInAccountId');
  console.log('🚀 accountId from localStorage:', accountIdFromStorage);
  
  // ✅ SIMPLIFIED CHECK - Just verify accountId exists
  if (!accountIdFromStorage) {
    console.log('❌ No LinkedIn account connected - opening modal');
    saveSchedulingState();
    setShowLinkedInModal(true);
    return;
  }
  
  // ✅ If accountId exists but linkedinStatus is not set, fix it
  const linkedinStatusFromStorage = localStorage.getItem('linkedinStatus');
  if (!linkedinStatusFromStorage || linkedinStatusFromStorage !== 'connected') {
    console.log('🔧 Fixing linkedinStatus in localStorage');
    localStorage.setItem('linkedinStatus', 'connected');
    setLinkedinStatus('connected');
  }
  
  console.log('✅ LinkedIn connected (accountId: ' + accountIdFromStorage + '), proceeding with scheduling');
  
  const selectedDraftData = drafts.find(d => d.id === selectedDraft);
  
  // Convert user's IST selection to 24-hour format
  let hour24 = scheduleHour;
  if (scheduleAMPM === 'PM' && scheduleHour !== 12) {
    hour24 = scheduleHour + 12;
  } else if (scheduleAMPM === 'AM' && scheduleHour === 12) {
    hour24 = 0;
  }
  
  const istDateString = `${scheduleYear}-${String(scheduleMonth + 1).padStart(2, '0')}-${String(scheduleDay).padStart(2, '0')}T${String(hour24).padStart(2, '0')}:${String(scheduleMinute).padStart(2, '0')}:00+05:30`;
  const scheduledDateUTC = new Date(istDateString);
  
  console.log('📅 User selected (IST):', `${scheduleYear}-${scheduleMonth + 1}-${scheduleDay} ${scheduleHour}:${String(scheduleMinute).padStart(2, '0')} ${scheduleAMPM}`);
  console.log('📅 UTC ISO string:', scheduledDateUTC.toISOString());

  // ✅ Parse accountId as integer
  const linkedinAccountIdInt = parseInt(accountIdFromStorage);
  
  console.log('📦 linkedinAccountId to send:', linkedinAccountIdInt);

  const schedulePayload = {
    post_content: selectedDraftData.content,
    media_url: selectedDraftData.image,
    scheduled_datetime: scheduledDateUTC.toISOString(),
    timezone: 'Asia/Kolkata',
    user_id: localStorage.getItem('userId'),
    linkedin_email: localStorage.getItem('linkedinEmail'),
    linkedinAccountId: linkedinAccountIdInt,
    draft_id: selectedDraft,
    prompt: postDescription,
    post_objective: postObjective,
    tone_style: toneStyle
  };

  if (editMode === 'reschedule' && postIdToEdit) {
    schedulePayload.postId = postIdToEdit;
  }

  console.log('📤 Final payload:', JSON.stringify(schedulePayload, null, 2));

  try {
    const endpoint = editMode === 'reschedule' 
      ? 'https://n8n.acespireconsulting.com/webhook/webhook/update-scheduled-post'
      : 'https://n8n.acespireconsulting.com/webhook/schedule-post';

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(schedulePayload),
    });

    if (response.ok) {
      console.log('✅ Post scheduled successfully!');
      clearSchedulingState();
      setCurrentStep(4);
    } else {
      const errorText = await response.text();
      console.error('❌ Schedule failed:', errorText);
      alert('Failed to schedule post: ' + errorText);
    }
  } catch (error) {
    console.error('❌ Network error:', error);
    alert('Error scheduling post: ' + error.message);
  }
};

// const schedulePost = async () => {
//   console.log('🚀 ============ SCHEDULE POST CALLED ============');
//   console.log('🚀 linkedinStatus state:', linkedinStatus);
//   console.log('🚀 localStorage linkedinStatus:', localStorage.getItem('linkedinStatus'));
  
//   // ✅ Read accountId from localStorage
//   const accountIdFromStorage = localStorage.getItem('selectedLinkedInAccountId');
//   console.log('🚀 accountId from localStorage:', accountIdFromStorage);
//   console.log('🚀 Type:', typeof accountIdFromStorage);
  
//   // Check if LinkedIn is connected
//   if (linkedinStatus === 'guest') {
//     console.log('❌ LinkedIn not connected - showing modal');
//     saveSchedulingState();
//     setShowLinkedInModal(true);
//     return;
//   }
  
//   // ✅ Validate accountId exists
//   if (!accountIdFromStorage) {
//     console.error('❌ ERROR: linkedinStatus is connected but accountId is missing!');
//     alert('LinkedIn connection error. Please reconnect your account.');
    
//     // Reset status and show modal
//     localStorage.removeItem('linkedinStatus');
//     setLinkedinStatus('guest');
//     saveSchedulingState();
//     setShowLinkedInModal(true);
//     return;
//   }
  
//   console.log('✅ LinkedIn connected and accountId verified, proceeding...');
  
//   const selectedDraftData = drafts.find(d => d.id === selectedDraft);
  
//   // Convert user's IST selection to 24-hour format
//   let hour24 = scheduleHour;
//   if (scheduleAMPM === 'PM' && scheduleHour !== 12) {
//     hour24 = scheduleHour + 12;
//   } else if (scheduleAMPM === 'AM' && scheduleHour === 12) {
//     hour24 = 0;
//   }
  
//   const istDateString = `${scheduleYear}-${String(scheduleMonth + 1).padStart(2, '0')}-${String(scheduleDay).padStart(2, '0')}T${String(hour24).padStart(2, '0')}:${String(scheduleMinute).padStart(2, '0')}:00+05:30`;
//   const scheduledDateUTC = new Date(istDateString);
  
//   console.log('📅 User selected (IST):', `${scheduleYear}-${scheduleMonth + 1}-${scheduleDay} ${scheduleHour}:${String(scheduleMinute).padStart(2, '0')} ${scheduleAMPM}`);
//   console.log('📅 IST string:', istDateString);
//   console.log('📅 UTC ISO string:', scheduledDateUTC.toISOString());

//   // ✅ Parse accountId as integer
//   const linkedinAccountIdInt = parseInt(accountIdFromStorage);
  
//   console.log('📦 Preparing payload...');
//   console.log('📦 linkedinAccountId (parsed):', linkedinAccountIdInt);
//   console.log('📦 linkedinAccountId type:', typeof linkedinAccountIdInt);

//   const schedulePayload = {
//     post_content: selectedDraftData.content,
//     media_url: selectedDraftData.image,
//     scheduled_datetime: scheduledDateUTC.toISOString(),
//     timezone: 'Asia/Kolkata',
//     user_id: localStorage.getItem('userId'),
//     linkedin_email: localStorage.getItem('linkedinEmail'),
//     linkedinAccountId: linkedinAccountIdInt, // ✅ Use parsed integer
//     draft_id: selectedDraft,
//     prompt: postDescription,
//     post_objective: postObjective,
//     tone_style: toneStyle
//   };

//   // If rescheduling, include the post ID
//   if (editMode === 'reschedule' && postIdToEdit) {
//     schedulePayload.postId = postIdToEdit;
//   }

//   console.log('📤 ============ FINAL PAYLOAD ============');
//   console.log(JSON.stringify(schedulePayload, null, 2));
//   console.log('📤 linkedinAccountId in payload:', schedulePayload.linkedinAccountId);
//   console.log('📤 linkedinAccountId type:', typeof schedulePayload.linkedinAccountId);

//   try {
//     const endpoint = editMode === 'reschedule' 
//       ? 'https://n8n.acespireconsulting.com/webhook/webhook/update-scheduled-post'
//       : 'https://n8n.acespireconsulting.com/webhook/schedule-post';

//     console.log('🌐 Sending request to:', endpoint);

//     const response = await fetch(endpoint, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(schedulePayload),
//     });

//     console.log('🌐 Response status:', response.status);

//     if (response.ok) {
//       console.log('✅ Schedule successful!');
//       clearSchedulingState();
//       setCurrentStep(4);
//     } else {
//       const errorText = await response.text();
//       console.error('❌ Schedule failed:', errorText);
//       alert('Failed to schedule post: ' + errorText);
//     }
//   } catch (error) {
//     console.error('❌ Network error:', error);
//     alert('Error scheduling post: ' + error.message);
//   }
// };

  // Format selected time for display
  const getFormattedTime = () => {
    const displayHour = scheduleHour;
    const displayMinute = scheduleMinute.toString().padStart(2, '0');
    return `${displayHour}:${displayMinute} ${scheduleAMPM}`;
  };

  // Add LinkedIn connection success handler
const handleLinkedInConnected = (newAccountId) => {  // ✅ Accept accountId parameter
  console.log('🟢 handleLinkedInConnected called with accountId:', newAccountId);
  
  // ✅ Set LinkedIn status
  localStorage.setItem('linkedinStatus', 'connected');
  setLinkedinStatus('connected');
  
  // ✅ Store accountId if provided
  if (newAccountId) {
    localStorage.setItem('selectedLinkedInAccountId', newAccountId.toString());
    console.log('✅ LinkedIn accountId stored:', newAccountId);
  }
  
  // Close modal
  setShowLinkedInModal(false);
  
  console.log('✅ LinkedIn connected successfully');
  
  // Replace URL
  window.history.replaceState({ page: 'create-post' }, '', '/create-post');
  
  // Trigger account changed event
  window.dispatchEvent(new Event('accountChanged'));
  
  // ✅ Log final state
  setTimeout(() => {
    console.log('📊 Final state after connection:', {
      linkedinStatus: linkedinStatus,
      accountId: localStorage.getItem('selectedLinkedInAccountId'),
      status: localStorage.getItem('linkedinStatus')
    });
    
    const savedState = localStorage.getItem('schedulingState');
    if (savedState) {
      console.log('📋 State will be restored by useEffect');
    }
  }, 100);
};

// const handleLinkedInConnected = (newAccountId) => {
//   console.log('🟢 handleLinkedInConnected called');
//   console.log('🟢 Received accountId parameter:', newAccountId);
//   console.log('🟢 Type of accountId:', typeof newAccountId);
  
//   // ✅ Double-check localStorage
//   const storedAccountId = localStorage.getItem('selectedLinkedInAccountId');
//   console.log('🟢 localStorage accountId:', storedAccountId);
  
//   // ✅ Set LinkedIn status
//   localStorage.setItem('linkedinStatus', 'connected');
//   setLinkedinStatus('connected');
  
//   console.log('✅ Set linkedinStatus to: connected');
  
//   // ✅ Make sure accountId is stored
//   if (newAccountId) {
//     localStorage.setItem('selectedLinkedInAccountId', newAccountId.toString());
//     console.log('✅ LinkedIn accountId stored:', newAccountId);
//   } else if (storedAccountId) {
//     console.log('✅ Using accountId from localStorage:', storedAccountId);
//   } else {
//     console.error('❌ WARNING: No accountId available!');
//   }
  
//   // Close modal
//   setShowLinkedInModal(false);
  
//   console.log('✅ Modal closed');
  
//   // Replace URL to clean up any query params
//   window.history.replaceState({ page: 'create-post' }, '', '/create-post');
  
//   // Trigger hook to reload
//   window.dispatchEvent(new Event('accountChanged'));
  
//   console.log('✅ LinkedIn connection complete');
  
//   // Show final state
//   setTimeout(() => {
//     console.log('📊 Final localStorage state:', {
//       accountId: localStorage.getItem('selectedLinkedInAccountId'),
//       accountType: localStorage.getItem('selectedAccountType'),
//       status: localStorage.getItem('linkedinStatus'),
//       email: localStorage.getItem('linkedinEmail')
//     });
    
//     const savedState = localStorage.getItem('schedulingState');
//     if (savedState) {
//       console.log('📋 State will be restored by useEffect');
//     }
//   }, 100);
// };
  // const Header = () => (
  //   <div className="flex items-center justify-between mb-4 lg:mb-6">
  //     <div className="flex items-center">
  //       <button 
  //         className="lg:hidden mr-3 p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
  //         onClick={() => setSidebarOpen(true)}
  //       >
  //         <Menu className="w-5 h-5" />
  //       </button>
  //       <button className="flex items-center px-3 py-2 lg:px-4 lg:py-2 bg-blue-50 text-blue-600 rounded-lg text-sm">
  //         <Sparkles className="w-4 h-4 mr-2" />
  //         <span className="hidden sm:inline">LinkedIn</span>
  //         <ChevronRight className="w-4 h-4 ml-1" />
  //       </button>
  //     </div>
  //     <div className="flex items-center space-x-2 lg:space-x-3">
  //       <button className="hidden sm:flex items-center px-3 py-2 lg:px-4 lg:py-2 text-gray-600 hover:bg-gray-50 rounded-lg text-sm">
  //         <Share className="w-4 h-4 mr-2" />
  //         Log out
  //       </button>
  //       <button className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
  //         <User className="w-4 h-4" />
  //       </button>
  //     </div>
  //   </div>
  // );

  const ProgressBar = () => (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <div className={`w-4 h-4 rounded-full ${currentStep >= 1 ? 'bg-gray-800' : 'bg-gray-300'} mr-2`}></div>
          <span className={`text-sm ${currentStep >= 1 ? 'text-gray-800 font-medium' : 'text-gray-500'}`}>Prompt</span>
        </div>
        <div className="flex-1 h-0.5 bg-gray-300 mx-4"></div>
        <div className="flex items-center">
          <div className={`w-4 h-4 rounded-full ${currentStep >= 2 ? 'bg-gray-800' : 'bg-gray-300'} mr-2`}></div>
          <span className={`text-sm ${currentStep >= 2 ? 'text-gray-800 font-medium' : 'text-gray-500'}`}>Draft</span>
        </div>
        <div className="flex-1 h-0.5 bg-gray-300 mx-4"></div>
        <div className="flex items-center">
          <div className={`w-4 h-4 rounded-full ${currentStep >= 3 ? 'bg-gray-800' : 'bg-gray-300'} mr-2`}></div>
          <span className={`text-sm ${currentStep >= 3 ? 'text-gray-800 font-medium' : 'text-gray-500'}`}>Schedule Post</span>
        </div>
      </div>
    </div>
  );

const EditMessageBox = React.memo(({ initialContent, onSave, onCancel }) => {
  const [localContent, setLocalContent] = React.useState(initialContent);
  const textareaRef = React.useRef(null);

  // Auto-focus + cursor at end on mount
  React.useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.focus();
      const len = textareaRef.current.value.length;
      textareaRef.current.setSelectionRange(len, len);
    }
  }, []);

  // Auto-resize height as user types
  React.useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [localContent]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (localContent.trim()) onSave(localContent.trim());
    }
    if (e.key === 'Escape') onCancel();
  };

  return (
    <div className="w-full" style={{ minWidth: '490px', maxWidth: '560px' }}>
      <textarea
        ref={textareaRef}
        value={localContent}
        onChange={(e) => setLocalContent(e.target.value)}
        onKeyDown={handleKeyDown}
        rows={4}
        className="w-full px-4 py-3 text-sm border-2 border-blue-400 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-gray-800 shadow-sm leading-relaxed"
        style={{
          minHeight: '96px',
          width: '100%',
          boxSizing: 'border-box',
          overflow: 'hidden',       // hide scrollbar while auto-resizing
        }}
      />
      <div className="flex gap-2 mt-2 justify-end">
        <button
          onClick={onCancel}
          className="px-4 py-1.5 text-xs rounded-lg bg-white border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors font-medium"
        >
          Cancel
        </button>
        <button
          onClick={() => { if (localContent.trim()) onSave(localContent.trim()); }}
          disabled={!localContent.trim()}
          className={`px-4 py-1.5 text-xs rounded-lg font-medium transition-colors ${
            localContent.trim()
              ? 'bg-blue-500 text-white hover:bg-blue-600'
              : 'bg-gray-200 text-gray-400 cursor-not-allowed'
          }`}
        >
          Send
        </button>
      </div>
      <p className="text-[10px] text-gray-400 mt-1 text-right">
        Enter to send • Shift+Enter for new line • Esc to cancel
      </p>
    </div>
  );
});

  const Step1_Prompt = () => {
    return (
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-2xl lg:text-3xl font-semibold text-gray-800 mb-2">Let's Create a Post</h1>
          <p className="text-gray-600">Chat with AI to refine your ideas, then generate drafts</p>
          {/* <p className="text-xs text-gray-400 mt-1">Session: {sessionId.substring(0, 20)}...</p> */}
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          {/* Post Objective and Tone Style */}
          <div className="px-6 pt-6">
            <div className="flex flex-col lg:flex-row gap-4 mb-6">
              <div className="flex-1">
                <select
                  value={postObjective}
                  onChange={(e) => setPostObjective(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700 bg-white"
                  disabled={isGeneratingDrafts || isAIResponding}
                >
                  <option value="">Select Post Objective</option>
                  <option value="brand-awareness">Brand Awareness</option>
                  <option value="engagement">Increase Engagement</option>
                  <option value="lead-generation">Lead Generation</option>
                  <option value="thought-leadership">Thought Leadership</option>
                  <option value="product-launch">Product Launch</option>
                  <option value="community-building">Community Building</option>
                </select>
              </div>
              <div className="flex-1">
                <select
                  value={toneStyle}
                  onChange={(e) => setToneStyle(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-gray-700 bg-white"
                  disabled={isGeneratingDrafts || isAIResponding}
                >
                  <option value="">Select Tone Style</option>
                  <option value="professional">Professional</option>
                  <option value="casual">Casual</option>
                  <option value="friendly">Friendly</option>
                  <option value="inspirational">Inspirational</option>
                  <option value="humorous">Humorous</option>
                  <option value="informative">Informative</option>
                </select>
              </div>
            </div>

          </div>

          {/* Chat Messages Area */}
          {chatMessages.length > 0 && (
            <div className="px-6 mb-4">
              <div 
                ref={chatContainerRef}
                className="max-h-80 overflow-y-auto bg-gray-50 rounded-lg p-4 pb-8 space-y-6 border"
              >
      

{chatMessages.map((message) => (
  <div key={message.id} className={`flex ${message.type === 'user' ? 'justify-end' : 'justify-start'}`}>
    <div className={`max-w-3xl w-full ${message.type === 'user' ? 'order-last' : 'order-first'}`}>
      <div className={`flex items-start gap-3 ${message.type === 'user' ? 'flex-row-reverse' : 'flex-row'}`}>

        {/* Avatar */}
        <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
          message.type === 'user'
            ? 'bg-blue-500 text-white'
            : 'bg-gradient-to-r from-purple-500 to-blue-500 text-white'
        }`}>
          {message.type === 'user' ? <User className="w-4 h-4" /> : <Sparkles className="w-4 h-4" />}
        </div>

        {/* Bubble + action row */}
        <div className={`flex flex-col gap-1 ${message.type === 'user' ? 'items-end' : 'items-start'}`}>

          {/* ── Edit mode: renders isolated component, NO parent re-render on typing ── */}
          {editingMessageId === message.id ? (
            <EditMessageBox
              initialContent={message.content}
              onSave={(newContent) => handleSaveEdit(message.id, newContent)}
              onCancel={() => setEditingMessageId(null)}
            />
          ) : (
            /* ── Normal bubble ── */
            <div
              className={`group relative rounded-2xl px-4 py-3 ${
                message.type === 'user'
                  ? 'bg-blue-500 text-white'
                  : 'bg-white text-gray-800 shadow-sm border'
              }`}
            >
              {message.edited && (
                <span className={`text-[10px] mr-1 opacity-60 ${
                  message.type === 'user' ? 'text-blue-100' : 'text-gray-400'
                }`}>(edited)</span>
              )}

              <p className="text-sm leading-relaxed whitespace-pre-wrap">{message.content}</p>

              <p className={`text-xs mt-1 opacity-70 ${
                message.type === 'user' ? 'text-blue-100' : 'text-gray-500'
              }`}>
                {message.timestamp}
              </p>

              {/* Hover action buttons */}
              <div className={`absolute -bottom-7 flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-150 z-10 ${
                message.type === 'user' ? 'right-0' : 'left-0'
              }`}>
                <button
                  onClick={() => handleCopyMessage(message.id, message.content)}
                  title="Copy message"
                  className="flex items-center gap-1 px-2 py-1 rounded-md bg-white border border-gray-200 shadow-sm text-gray-500 hover:text-gray-800 hover:bg-gray-50 transition-all text-xs whitespace-nowrap"
                >
                  {copiedMessageId === message.id ? (
                    <><Check className="w-3 h-3 text-green-500" /><span className="text-green-500">Copied!</span></>
                  ) : (
                    <><Copy className="w-3 h-3" /></>
                  )}
                </button>

                {message.type === 'user' && (
                  <button
                    onClick={() => setEditingMessageId(message.id)}
                    title="Edit message"
                    className="flex items-center gap-1 px-2 py-1 rounded-md bg-white border border-gray-200 shadow-sm text-gray-500 hover:text-gray-800 hover:bg-gray-50 transition-all text-xs whitespace-nowrap"
                  >
                    <Edit2 className="w-3 h-3" />
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
))}

                
                {/* AI Thinking Indicator */}
                {isAIResponding && (
                  <div className="flex justify-start">
                    <div className="flex items-start gap-3">
                      <div className="w-8 h-8 rounded-full bg-gradient-to-r from-purple-500 to-blue-500 text-white flex items-center justify-center flex-shrink-0">
                        <Sparkles className="w-4 h-4" />
                      </div>
                      <div className="bg-white rounded-2xl px-4 py-3 shadow-sm border">
                        <div className="flex items-center space-x-1">
                          <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse"></div>
                          <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
                          <div className="w-2 h-2 bg-gray-400 rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Chat Input Area */}
{/* Chat Input Area */}
<div className="px-6 pb-6">
  <div className="relative">
    <textarea
      ref={textareaRef}
      value={postDescription}
      onChange={handleTextInput}
      onKeyPress={handleKeyPress}
      placeholder={chatMessages.length === 0 
        ? "Describe your post idea or ask me anything about content creation..." 
        : "Continue the conversation or ask follow-up questions..."}
      rows={3}
      disabled={isGeneratingDrafts || isAIResponding}
      className="w-full px-4 py-3 pr-20 pl-12 border border-gray-700 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"
      style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontSize: '14px',
        lineHeight: '1.5'
      }}
    />
    
    {/* File Upload Button - Left side */}
    <div className="absolute bottom-3 left-3">
      <input
        type="file"
        id="inline-file-input"
        multiple
        accept="image/*,video/*,.pdf,.doc,.docx"
        onChange={handleFileUpload}
        className="hidden"
        disabled={isGeneratingDrafts || isAIResponding}
      />
      <label
        htmlFor="inline-file-input"
        className={`w-8 h-8 rounded-full flex items-center justify-center transition-all cursor-pointer ${
          isGeneratingDrafts || isAIResponding
            ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
            : 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-800'
        }`}
        title="Attach files"
      >
        <Paperclip className="w-4 h-4" />
      </label>
    </div>

    {/* Send Button - Right side */}
    <button
      onClick={sendMessageToAI}
      disabled={!postDescription.trim() || isAIResponding || isGeneratingDrafts}
      className={`absolute bottom-3 right-3 w-8 h-8 rounded-full flex items-center justify-center transition-all ${
        postDescription.trim() && !isAIResponding && !isGeneratingDrafts
          ? 'bg-blue-500 text-white hover:bg-blue-600 shadow-sm'
          : 'bg-gray-200 text-gray-400 cursor-not-allowed'
      }`}
    >
      {isAIResponding ? (
        <div className="animate-spin w-4 h-4 border-2 border-white border-t-transparent rounded-full"></div>
      ) : (
        <ArrowUp className="w-4 h-4" />
      )}
    </button>
  </div>
  
  {/* Show Attached Files - Compact display below textarea */}
  {attachedFiles.length > 0 && (
    <div className="mt-3 flex flex-wrap gap-2">
      {attachedFiles.map((file, index) => (
        <div 
          key={index} 
          className="flex items-center bg-blue-50 text-blue-800 px-2 py-1 rounded-full text-xs border border-blue-200"
        >
          <Paperclip className="w-3 h-3 mr-1" />
          <span className="max-w-20 truncate">{file.name}</span>
          <button
            onClick={() => removeFile(index)}
            className="ml-1 text-blue-600 hover:text-blue-800"
            disabled={isGeneratingDrafts || isAIResponding}
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      ))}
    </div>
  )}
  
  <p className="text-xs text-gray-500 mt-2 text-center">
    Press Enter to chat with AI • Shift+Enter for new line • Click 📎 to attach files
  </p>
</div>
            
          {/* Generate Drafts Button */}
          <div className="px-6 pb-6 border-t bg-gray-50">
            <div className="pt-6 text-center">
              <button
                onClick={generateDrafts}
                disabled={isGeneratingDrafts || isAIResponding || (chatMessages.length === 0 && !postDescription.trim())}
                className={`inline-flex items-center px-8 py-3 rounded-lg font-medium transition-all duration-200 ${
                  isGeneratingDrafts || isAIResponding || (chatMessages.length === 0 && !postDescription.trim())
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-blue-600 text-white hover:bg-blue-700 hover:shadow-lg'
                }`}
              >
                {isGeneratingDrafts ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                    Generating Drafts...
                  </>
                ) : (
                  <>
                    <Sparkles className="w-5 h-5 mr-2" />
                    Generate 3 Drafts
                  </>
                )}
              </button>
              <p className="text-xs text-gray-600 mt-2">
                Ready to create posts? Click to generate 3 draft variations
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const Step2_Drafts = () => {
    // Show loading state if no drafts yet
    if (drafts.length === 0) {
      return (
        <div className="max-w-6xl mx-auto">
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading generated drafts...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">Choose Your Draft</h2>
          <p className="text-gray-600">Select the draft you'd like to schedule</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          {drafts.map((draft) => (
            <div
              key={draft.id}
              className={`bg-white rounded-lg p-4 shadow-sm border-2 transition-all cursor-pointer ${
                selectedDraft === draft.id ? 'border-blue-500 ring-2 ring-blue-200' : 'border-transparent hover:border-gray-200'
              }`}
              onClick={() => setSelectedDraft(draft.id)}
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mr-3">
                    <span className="text-white text-sm font-semibold">AC</span>
                  </div>
                  <div>
                    <h3 className="font-semibold text-sm">{draft.user}</h3>
                    <p className="text-xs text-gray-500">{draft.date}</p>
                  </div>
                </div>
                
                <div className="flex items-center space-x-2">
  <button 
    onClick={(e) => {
      e.stopPropagation();
      setPreviewDraft(draft);
    }}
    className="text-blue-600 text-sm hover:underline flex items-center"
    title="Preview post"
  >
    <Eye className="w-4 h-4 mr-1" />
    Preview
  </button>

  {/* ── Copy draft content button ── */}
  <button
    onClick={(e) => {
      e.stopPropagation();
      handleCopyDraft(draft.id, draft.content);
    }}
    title="Copy post content"
    className={`flex items-center text-sm transition-colors ${
      copiedDraftId === draft.id
        ? 'text-green-600'
        : 'text-gray-500 hover:text-gray-800'
    }`}
  >
    {copiedDraftId === draft.id ? (
      <><Check className="w-4 h-4 mr-1" /><span className="text-xs font-medium">Copied!</span></>
    ) : (
      <><Copy className="w-4 h-4 mr-1" /></>
    )}
  </button>

  {draft.image && (
    <button 
      onClick={(e) => {
        e.stopPropagation();
        handleDownloadImage(draft.image, draft.id);
      }}
      className="text-green-600 hover:text-green-700"
      title="Download image"
    >
      <Download className="w-4 h-4" />
    </button>
  )}
</div>
              </div>

              <div className="mb-3">
                <p className="text-sm text-gray-800 leading-relaxed whitespace-pre-line">{draft.content}</p>
                {/* <button className="text-blue-600 text-sm hover:underline mt-1">{draft.translation}</button> */}
              </div>

              {draft.image && (
                <div className="mb-3">
                  <div className="w-full h-32 bg-gray-100 rounded-lg overflow-hidden">
                    <img 
                      src={imageBlobUrls[draft.image] || draft.image} 
                      alt="Post media" 
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        // Fallback if image fails to load
                        e.target.style.display = 'none';
                        e.target.nextElementSibling.style.display = 'flex';
                      }}
                    />
                    {/* Fallback placeholder */}
                    <div 
                      className="w-full h-full bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg flex items-center justify-center"
                      style={{ display: 'none' }}
                    >
                      <div className="text-center">
                        <div className="w-16 h-16 bg-blue-500 rounded-lg mx-auto mb-2 flex items-center justify-center">
                          <span className="text-white text-xl">🖼️</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p className="text-xs text-gray-600 mt-2">{draft.facts}</p>
                </div>
              )}

              <div className="flex items-center justify-between text-gray-500 text-xs border-t pt-3">
                <div className="flex items-center space-x-4">
                  <button className="flex items-center hover:text-blue-600">
                    <ThumbsUp className="w-4 h-4 mr-1" />
                    {draft.engagement.likes}
                  </button>
                  <button className="flex items-center hover:text-green-600">
                    <Repeat2 className="w-4 h-4 mr-1" />
                    {draft.engagement.reposts}
                  </button>
                  <button className="flex items-center hover:text-purple-600">
                    <MessageCircle className="w-4 h-4 mr-1" />
                    {draft.engagement.comments}
                  </button>
                </div>
                {selectedDraft === draft.id && (
                  <div className="text-blue-600 text-xs font-medium">Selected</div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center space-x-4">
          <button
            onClick={() => setCurrentStep(1)}
            className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
          >
            Back to Edit
          </button>
          <button
            onClick={() => setCurrentStep(3)}
            disabled={!selectedDraft}
            className={`px-8 py-3 rounded-lg font-medium transition-colors ${
              selectedDraft
                ? 'bg-blue-600 text-white hover:bg-blue-700'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
          >
            Schedule Selected Draft
          </button>
        </div>
        {/* Preview Modal */}
{previewDraft && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto no-scrollbar">
      <div className="sticky top-0 bg-white border-b px-6 py-4 flex items-center justify-between">
        <h3 className="text-xl font-semibold text-gray-800">Post Preview</h3>
        <button
          onClick={() => setPreviewDraft(null)}
          className="text-gray-400 hover:text-gray-600"
        >
          <X className="w-6 h-6" />
        </button>
      </div>
      
      <div className="p-6">
        <div className="bg-white rounded-lg border shadow-sm p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mr-3">
                <span className="text-white font-semibold">AC</span>
              </div>
              <div>
                <h3 className="font-semibold">{previewDraft.user}</h3>
                <p className="text-sm text-gray-500">{previewDraft.date}</p>
              </div>
            </div>
            <button className="text-gray-400">
              <MoreHorizontal className="w-5 h-5" />
            </button>
          </div>

          <div className="mb-4">
            <p className="text-gray-800 text-sm leading-relaxed whitespace-pre-line">{previewDraft.content}</p>
            {previewDraft.translation && (
              <button className="text-blue-600 text-sm hover:underline mt-2">{previewDraft.translation}</button>
            )}
          </div>

          {previewDraft.image && (
            <div className="mb-4">
              <div className="w-full h-[200px] rounded-lg overflow-hidden bg-gray-100">
                <img 
                  src={imageBlobUrls[previewDraft.image] || previewDraft.image}
                  alt="Post media" 
                  className="w-full h-[200px] object-cover"
                />
              </div>
              {previewDraft.facts && (
                <p className="text-sm text-gray-600 mt-2">{previewDraft.facts}</p>
              )}
            </div>
          )}

          <div className="flex items-center justify-between text-gray-500 border-t pt-2">
            <div className="flex items-center space-x-6">
              <button className="flex items-center hover:text-blue-600 transition-colors">
                <ThumbsUp className="w-3 h-3 mr-2" />
                <span className="text-xs">{previewDraft.engagement.likes}</span>
              </button>
              <button className="flex items-center hover:text-green-600 transition-colors">
                <Repeat2 className="w-3 h-3 mr-2" />
                <span className="text-xs">{previewDraft.engagement.reposts}</span>
              </button>
              <button className="flex items-center hover:text-purple-600 transition-colors">
                <MessageCircle className="w-3 h-3 mr-2" />
                <span className="text-xs">{previewDraft.engagement.comments}</span>
              </button>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end space-x-3">
          {previewDraft.image && (
            <button
              onClick={() => handleDownloadImage(previewDraft.image, previewDraft.id)}
              className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors flex items-center"
            >
              <Download className="w-4 h-4 mr-2" />
              Download Image
            </button>
          )}
          <button
            onClick={() => {
              setSelectedDraft(previewDraft.id);
              setPreviewDraft(null);
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Select This Draft
          </button>
        </div>
      </div>
    </div>
  </div>
)}
      </div>
    );
  };

  const Step3_Schedule = () => (
    <div className="max-w-4xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Post Preview */}
        <div className="bg-white rounded-lg p-6 shadow-sm">
          <div className="flex items-start justify-between mb-3">
            <div className="flex items-center">
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mr-3">
                <span className="text-white text-sm font-semibold">AC</span>
              </div>
              <div>
                <h3 className="font-semibold text-sm">Acespire Consulting</h3>
                {/* <p className="text-xs text-gray-500">2h • 3rd</p> */}
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <button className="text-blue-600 text-sm hover:underline">Follow</button>
              <button className="text-gray-400">
                <MoreHorizontal className="w-4 h-4" />
              </button>
            </div>
          </div>

          <div className="mb-3">
            <p className="text-sm text-gray-800 leading-relaxed">
              {selectedDraft ? drafts.find(d => d.id === selectedDraft)?.content : "🚗 New Car, First Service Done! 🚗\nLoving my new Hyundai i20 N-line—smooth ride & packed with features! Just completed the first service; quick, efficient, and hassle-free. Ready for many more miles ahead! 🏁\n...see more\n\n#NewCar #FirstService #SmoothDrive #Hassle-free"}
            </p>
            <button className="text-blue-600 text-sm hover:underline mt-1">See translation</button>
          </div>

          {selectedDraft && drafts.find(d => d.id === selectedDraft)?.image && (
            <div className="mb-3">
              <div className="w-full h-48 bg-gray-100 rounded-lg overflow-hidden">
                 {(() => {
        const imageUrl = drafts.find(d => d.id === selectedDraft)?.image;
        return (
          <img 
            src={imageBlobUrls[imageUrl] || imageUrl}
            alt="Post media" 
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextElementSibling.style.display = 'flex';
            }}
          />
        );
      })()}
                <div 
                  className="w-full h-full bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg flex items-center justify-center"
                  style={{ display: 'none' }}
                >
                  <div className="text-center">
                    <div className="w-20 h-20 bg-blue-500 rounded-lg mx-auto mb-2 flex items-center justify-center">
                      <span className="text-white text-2xl">🖼️</span>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-600 mt-2">{drafts.find(d => d.id === selectedDraft)?.facts}</p>
            </div>
          )}

          {!selectedDraft && (
            <div className="mb-3">
              <div className="w-full h-48 bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg flex items-center justify-center">
                <div className="text-center">
                  <div className="w-20 h-20 bg-blue-500 rounded-lg mx-auto mb-2 flex items-center justify-center">
                    <span className="text-white text-2xl">🚗</span>
                  </div>
                </div>
              </div>
              <p className="text-xs text-gray-600 mt-2">Sample post preview</p>
            </div>
          )}

          <div className="flex items-center justify-between text-gray-500 text-xs border-t pt-3">
            <div className="flex items-center space-x-4">
              <button className="flex items-center hover:text-blue-600">
                <ThumbsUp className="w-4 h-4 mr-1" />
                0
              </button>
              <button className="flex items-center hover:text-green-600">
                <Repeat2 className="w-4 h-4 mr-1" />
                0
              </button>
              <button className="flex items-center hover:text-purple-600">
                <MessageCircle className="w-4 h-4 mr-1" />
                0
              </button>
            </div>
          </div>
        </div>

        {/* Schedule Options */}
        <div className="space-y-6">
          <div>
            <h2 className="text-xl font-semibold mb-2">Schedule Post</h2>
            <p className="text-gray-600 text-sm">Choose when to publish and who can see your post</p>
          </div>

          <div>
            <h3 className="font-medium mb-3">Schedule</h3>
            <p className="text-sm text-gray-600 mb-2">Select a date to make your post <span className="font-medium">Public</span></p>
            
            <div className="mb-4">
              {/* <h4 className="font-medium text-sm mb-2">Schedule as public</h4>
              <p className="text-sm text-gray-600 mb-3">Select a date to make your post <span className="font-medium">Public</span></p> */}
              
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
                {/* Year Selector */}
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Year</label>
                  <select
                    value={scheduleYear}
                    onChange={(e) => setScheduleYear(parseInt(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {years.map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>

                {/* Month Selector */}
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Month</label>
                  <select
                    value={scheduleMonth}
                    onChange={(e) => setScheduleMonth(parseInt(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {months.map((month, index) => (
                      <option key={index} value={index}>{month}</option>
                    ))}
                  </select>
                </div>

                {/* Day Selector */}
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Day</label>
                  <select
                    value={scheduleDay}
                    onChange={(e) => setScheduleDay(parseInt(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {days.map(day => (
                      <option key={day} value={day}>{day}</option>
                    ))}
                  </select>
                </div>
              </div>

              {/* Time Selector */}
              <div className="grid grid-cols-1 sm:grid-cols-4 gap-3 mb-4">
                {/* Hour */}
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Hour</label>
                  <select
                    value={scheduleHour}
                    onChange={(e) => setScheduleHour(parseInt(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {hours.map(hour => (
                      <option key={hour} value={hour}>{hour}</option>
                    ))}
                  </select>
                </div>

                {/* Minute */}
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Minute</label>
                  <select
                    value={scheduleMinute}
                    onChange={(e) => setScheduleMinute(parseInt(e.target.value))}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    {minutes.map(minute => (
                      <option key={minute} value={minute}>{minute.toString().padStart(2, '0')}</option>
                    ))}
                  </select>
                </div>

                {/* AM/PM */}
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Period</label>
                  <select
                    value={scheduleAMPM}
                    onChange={(e) => setScheduleAMPM(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="AM">AM</option>
                    <option value="PM">PM</option>
                  </select>
                </div>

                {/* Display selected time */}
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Selected</label>
                  <div className="px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg text-sm">
                    {getFormattedTime()}
                  </div>
                </div>
              </div>

              {/* Timezone Selector */}
              <div className="mb-4">
                <label className="block text-xs text-gray-500 mb-1">Time Zone</label>
                <select
                  value={scheduleTimezone}
                  onChange={(e) => setScheduleTimezone(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {timezones.map(timezone => (
                    <option key={timezone} value={timezone}>{timezone}</option>
                  ))}
                </select>
              </div>

              {/* Display selected date and time */}
              <div className="bg-blue-50 p-3 rounded-lg">
                <p className="text-sm font-medium text-blue-800">
                  Scheduled for: {getFormattedDate()} at {getFormattedTime()} ({scheduleTimezone.split('(')[1]?.replace(')', '') || 'IST'})
                </p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-medium mb-3">Before you publish, kindly check the following:</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>• Make sure the content is Correct</li>
              <li>• No copyrights are found.</li>
              <li>• You can edit the post if needed.</li>
            </ul>
            
            <button
              onClick={() => setCurrentStep(1)}
              className="flex items-center px-4 py-2 text-blue-600 hover:bg-blue-50 rounded-lg mt-3"
            >
              <Edit3 className="w-4 h-4 mr-2" />
              Edit Post
            </button>
          </div>

          <div className="flex space-x-4 pt-4">
            <button
              onClick={() => setCurrentStep(2)}
              className="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
            >
              Back
            </button>
            <button
              onClick={schedulePost}
              className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              Schedule Post
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const Step4_Confirmation = () => {
  // Add delete handler function - NEW
  const handleDeleteScheduledPost = async () => {
    if (!window.confirm('Are you sure you want to delete this scheduled post?')) {
      return;
    }

    try {
      const response = await fetch('https://n8n.acespireconsulting.com/webhook/delete-scheduled-post', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          postId: postIdToEdit || selectedDraft 
        })
      });

      const result = await response.json();

      if (response.ok && result.success) {
        alert('Post deleted successfully!');
        // Navigate to scheduled posts page
        navigate('/scheduled-posts');
      } else {
        alert(result.error || 'Failed to delete post');
      }
    } catch (error) {
      console.error('Error deleting post:', error);
      alert('Failed to delete post. Please try again.');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 max-w-md w-full">
        <div className="text-center mb-6">
          <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-0">
            <Calendar className="w-6 h-6 text-green-600" />
          </div>
          
          {/* Post Preview */}
          <div className="bg-gray-50 rounded-lg p-4 mb-4 text-left">
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mr-2">
                  <span className="text-white text-xs font-semibold">AC</span>
                </div>
                <div>
                  <h3 className="font-semibold text-sm">Acespire Consulting</h3>
                  {/* <p className="text-xs text-gray-500">2h • 3rd</p> */}
                </div>
              </div>
              <div className="flex items-center space-x-1">
                <button className="text-blue-600 text-xs hover:underline">Follow</button>
                <button className="text-gray-400">
                  <MoreHorizontal className="w-3 h-3" />
                </button>
              </div>
            </div>

            <div className="mb-3">
              <p className="text-sm text-gray-800 leading-relaxed">
                {selectedDraft ? drafts.find(d => d.id === selectedDraft)?.content?.substring(0, 100) + "..." : "🚗 New Car, First Service Done! 🚗\nLoving my new Hyundai i20 N-line..."}
              </p>
              {/* <button className="text-blue-600 text-xs hover:underline mt-1">See translation</button> */}
            </div>
            {selectedDraft && drafts.find(d => d.id === selectedDraft)?.image && (
                        <div className="mb-3">
                          <div className="w-full h-48 bg-gray-100 rounded-lg overflow-hidden">
                           {(() => {
  const imageUrl = drafts.find(d => d.id === selectedDraft)?.image;
  return (
    <img 
      src={imageBlobUrls[imageUrl] || imageUrl}  // ✅ USE BLOB URL IF AVAILABLE
      alt="Post media" 
      className="w-full h-full object-cover"
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextElementSibling.style.display = 'flex';
                              }}
                            />
                              );
      })()}
                            <div 
                              className="w-full h-full bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg flex items-center justify-center"
                              style={{ display: 'none' }}
                            >
                              <div className="text-center">
                                <div className="w-20 h-20 bg-blue-500 rounded-lg mx-auto mb-2 flex items-center justify-center">
                                  <span className="text-white text-2xl">🖼️</span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <p className="text-xs text-gray-600 mt-2">{drafts.find(d => d.id === selectedDraft)?.facts}</p>
                        </div>
                      )}

            <div className="flex items-center justify-between text-gray-500 text-xs border-t pt-2">
              <div className="flex items-center space-x-3">
                <button className="flex items-center hover:text-blue-600">
                  <ThumbsUp className="w-3 h-3 mr-1" />
                  0
                </button>
                <button className="flex items-center hover:text-green-600">
                  <Repeat2 className="w-3 h-3 mr-1" />
                  0
                </button>
                <button className="flex items-center hover:text-purple-600">
                  <MessageCircle className="w-3 h-3 mr-1" />
                  0
                </button>
              </div>
            </div>
          </div>

          <p className="text-gray-800 text-sm font-medium mb-1">Your post is scheduled for {getFormattedDate()} at {getFormattedTime()}</p>
        </div>

        <div className="flex space-x-3">
          <button
            onClick={() => navigate('/scheduled-posts')}
            className="flex-1 flex items-center justify-center px-4 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 transition-colors"
          >
            <Calendar className="w-4 h-4 mr-2" />
            Calendar
          </button>
          <button
            onClick={handleDeleteScheduledPost} // ← UPDATED: Now calls delete handler
            className="flex-1 flex items-center justify-center px-4 py-2 text-red-600 border border-red-600 rounded-lg hover:bg-red-50 transition-colors"
          >
            <Trash2 className="w-4 h-4 mr-2" />
            Delete
          </button>
        </div>

        <button
          onClick={() => setCurrentStep(3)}
          className="w-full mt-4 px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors"
        >
          Back
        </button>
      </div>
    </div>
  );
};
  // Add loading screen in renderCurrentStep
  const renderCurrentStep = () => {
    if (isLoadingPost) {
      return (
        <div className="max-w-4xl mx-auto">
          <div className="text-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading post data...</p>
          </div>
        </div>
      );
    }
    
    switch (currentStep) {
      case 1:
        return Step1_Prompt();
      case 2:
        return <Step2_Drafts />;
      case 3:
        return <Step3_Schedule />;
      case 4:
        return <Step4_Confirmation />;
      default:
        return Step1_Prompt();
    }
  };

   return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="flex-1 flex flex-col min-w-0 lg:ml-64">
              <div className="flex-1 p-4 lg:p-8 overflow-y-auto">
                <Header />
          <ProgressBar />
          {renderCurrentStep()}
        </div>
      </div>
{showLinkedInModal && (
  <LinkedInConnectionModal
    isOpen={showLinkedInModal}
    onClose={() => setShowLinkedInModal(false)}
    onSuccess={handleLinkedInConnected}
  />
)}
    </div>
  );
};

export default CreatePostPage;